import ListFiles from "../UI/ListFiles";

export default function TenantShowFiles({ files, hideTitle = false }) {
  if (!files) return null;
  return (
    <>
      {!hideTitle && <h2>Liste des documents</h2>}
      {!hideTitle && <h3>Justificatif d'identité</h3>}
      <ListFiles
        files={files.filter((filtered) => filtered.tag === "identite")}
        displayName={hideTitle}
      />
      {!hideTitle && <h3>Justificatif de domicile</h3>}
      <ListFiles
        files={files.filter((filtered) => filtered.tag === "domicile")}
        displayName={hideTitle}
      />
      {!hideTitle && <h3>Justificatif de revenus</h3>}
      <ListFiles
        files={files.filter((filtered) => filtered.tag === "pro")}
        displayName={hideTitle}
      />
    </>
  );
}
